var map = {
	"./2.0.mdx": 246,
	"./about.mdx": 7599,
	"./alerts.mdx": 81002,
	"./dashboard-attachments-backgrounds.mdx": 62753,
	"./facebook-messenger.mdx": 16773,
	"./more-space-for-your-content.mdx": 69263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92916;